import { useQuery } from '@tanstack/react-query'
import { liveApi, type LiveTarget } from '@/api/live'

/**
 * Whether Live is on for the tenant, and the booking or session's current (or latest) live session. Shared by the
 * Live card and by pages that show a marker for a running session, so they read one cached answer.
 */
export function useLiveStatus(target: LiveTarget, enabled = true) {
  return useQuery({
    queryKey: ['live-status', target.bookingId ?? target.sessionId],
    queryFn: () => liveApi.getStatus(target).then(r => r.data),
    // While a room is open, keep an eye out for it ending (the presenter can end it from the console).
    refetchInterval: q => (q.state.data?.delivery?.status === 'Open' ? 10_000 : false),
    enabled,
  })
}
